const BLOGTYPE = {
  article: "article", //文章
  know: "know", //技能
  translate: "translate", //翻译
  externalStation: "externalStation", //工具-外部站点
}
export default BLOGTYPE